import { Component, OnInit } from '@angular/core';
import { TranslationUtil } from 'src/app/utils/translation-util';

@Component({
  selector: 'app-mes-produits-complementaires',
  templateUrl: './mes-produits-complementaires.component.html',
  styleUrls: ['./mes-produits-complementaires.component.scss'],
  providers: [TranslationUtil]
})
export class MesProduitsComplementairesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
